/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  ListsWidget26,
  EngageWidget10,
} from '../../../_metronic/partials/widgets'
import {CardsWidgetTiles} from '../../../_metronic/partials/widgets/_new/cards/CardsWidgetTiles'
import {
  ModelInfoDashboard,
  RegistroFuncionalidad,
  registroInfoDashboard,
  useAuth,
} from '../../modules/auth'
import {infoDashboard} from '../../modules/auth/core/_requests'

const DashboardPage: FC = () => {
  const intl = useIntl()
  const [data, setData] = useState<registroInfoDashboard | null>(null)
  const {currentUser, setCurrentUser} = useAuth()
  const [loading, setLoading] = useState<boolean>(true) // Estado de carga

  const getDataDashboard = async () => {
    setLoading(true) // Iniciar carga
    try {
      const {data: list} = await infoDashboard(
        currentUser ? currentUser?.registro.IdOrgV : '',
        currentUser ? currentUser?.registro.IdRol : '',
        [21],
        [22, 23, 24, 25, 26],
        {
          PorResponder: [27, 28, 29],
          EnRevision: [28],
          Atendidas: [30, 31],
        }
      )

      if (list.message.msgId == 0) {
        setData(list.registro)
      } else {
        setData(null)
      }
    } catch (error) {
      console.error(error)
    }
    setLoading(false) // Finalizar carga
  }

  useEffect(() => {
    getDataDashboard()
  }, [])

  const [dataAccesos, setDataAccesos] = useState<RegistroFuncionalidad[]>([])

  useEffect(() => {
    if (currentUser?.registro.funcionalidad) {
      setDataAccesos(currentUser.registro.funcionalidad)
    }
  }, [])

  function validarPorIdMenu(id: number) {
    return dataAccesos.some((item) => item.menu !== null && item.menu.IdMenu === id)
  }

  return (
    <>
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-md-5 mb-xl-10'>
          <CardsWidgetTiles
            className='h-md-50 mb-5 mb-xl-10'
            title={intl.formatMessage({id: 'DASHBOARD.USER'})}
            description={intl.formatMessage({id: 'DASHBOARD.TOTAL_REGISTERS'})}
            numberPrincipal={loading ? 'Cargando...' : data ? data.usuarios.countTotal : 0}
            // link='/menu/catalogo/usuarios'
            link={validarPorIdMenu(11) ? '/menu/catalogo/usuarios' : undefined}
            label1={intl.formatMessage({id: 'DASHBOARD.TODAY'})}
            numberLabel1={loading ? 'Cargando...' : data ? data.usuarios.countToday : 0}
            label2={intl.formatMessage({id: 'DASHBOARD.MONTH'})}
            numberLabel2={loading ? 'Cargando...' : data ? data.usuarios.countMonth : 0}
          />

          <CardsWidgetTiles
            className='h-md-50 mb-5 mb-xl-10'
            title={intl.formatMessage({id: 'DASHBOARD.BOOKING'})}
            description={intl.formatMessage({id: 'DASHBOARD.BOOKING_SERVED'})}
            numberPrincipal={loading ? 'Cargando...' : data ? data.reservas.countTotal : 0}
            // link='/menu/transacciones/reserva'
            link={validarPorIdMenu(15) ? '/menu/transacciones/reserva' : undefined}
            label1={intl.formatMessage({id: 'DASHBOARD.TODAY'})}
            numberLabel1={loading ? 'Cargando...' : data ? data.reservas.countToday : 0}
            label2={intl.formatMessage({id: 'DASHBOARD.MONTH'})}
            numberLabel2={loading ? 'Cargando...' : data ? data.reservas.countMonth : 0}
          />
        </div>

        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-md-5 mb-xl-10'>
          <CardsWidgetTiles
            className='h-md-50 mb-5 mb-xl-10'
            title={intl.formatMessage({id: 'DASHBOARD.QUOTATION'})}
            description={intl.formatMessage({id: 'DASHBOARD.QUOTATION_EARRING'})}
            numberPrincipal={loading ? 'Cargando...' : data ? data.cotizaciones.countTotal : 0}
            // link='/menu/transacciones/cotizacion'
            link={validarPorIdMenu(28) ? '/menu/transacciones/cotizacion' : undefined}
            label1={intl.formatMessage({id: 'DASHBOARD.TODAY'})}
            numberLabel1={loading ? 'Cargando...' : data ? data.cotizaciones.countToday : 0}
            label2={intl.formatMessage({id: 'DASHBOARD.MONTH'})}
            numberLabel2={loading ? 'Cargando...' : data ? data.cotizaciones.countMonth : 0}
          />

          <CardsWidgetTiles
            className='h-md-50 mb-5 mb-xl-10'
            title={intl.formatMessage({id: 'DASHBOARD.CONTACT_US'})}
            description={intl.formatMessage({id: 'DASHBOARD.CONTACT_US_REPLY'})}
            numberPrincipal={loading ? 'Cargando...' : data ? data.contactenos.countToAnswer : 0}
            // link='/menu/catalogo/contactenos'
            link={validarPorIdMenu(12) ? '/menu/catalogo/contactenos' : undefined}
            label1={intl.formatMessage({id: 'DASHBOARD.CONTACT_US_REVIEW'})}
            numberLabel1={loading ? 'Cargando...' : data ? data.contactenos.countToReview : 0}
            label2={intl.formatMessage({id: 'DASHBOARD.CONTACT_US_SERVED'})}
            numberLabel2={loading ? 'Cargando...' : data ? data.contactenos.countToAttend : 0}
          />
        </div>
        <div className='col-xxl-4 '>
          <EngageWidget10 className='h-md-100' />
        </div>
      </div>
    </>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
